import { GoogleMap, Circle as GoogleMapCircle } from '@capacitor/google-maps';
import { PreserveStringAlias } from 'src/app/utils/alias.utils';
import { CircleConfig } from './circle.config';

type CircleId = string & PreserveStringAlias;

export class Circle {
  private config: CircleConfig;
  private circleId: CircleId | null = null;

  private constructor(private map: GoogleMap) {}

  static async create(map: GoogleMap, config: CircleConfig): Promise<Circle> {
    const circle = new Circle(map);
    await circle.add(config);

    return circle;
  }

  async update(updateOpts: Partial<CircleConfig>): Promise<void> {
    if (!this.circleId) {
      return;
    }

    const opts = { ...this.config, ...updateOpts };

    await this.remove();
    await this.add(opts);
  }

  async remove(): Promise<void> {
    if (!this.circleId) {
      return;
    }

    await this.map.removeCircles([this.circleId]);
    this.circleId = null;
  }

  private async add(config: CircleConfig): Promise<void> {
    const gmCircle: GoogleMapCircle = this.convertCircleConfigToGoogleMapCircle(config);
    const idArray = await this.map.addCircles([gmCircle]);
    const id = idArray[0];

    this.config = config;
    this.circleId = id;
  }

  private convertCircleConfigToGoogleMapCircle(config: CircleConfig): GoogleMapCircle {
    const latLng: google.maps.LatLngLiteral = {
      lat: config.center.lat,
      lng: config.center.lng
    };

    const gmCircle: GoogleMapCircle = {
      center: latLng,
      radius: config.radius,
      strokeColor: config.strokeColor,
      strokeWeight: config.strokeWeight,
      strokeOpacity: config.strokeOpacity,
      fillColor: config.fillColor,
      fillOpacity: config.fillOpacity,
      geodesic: true,
      zIndex: config.zIndex
    };

    return gmCircle;
  }
}
